import React from "react";
import PropTypes from "prop-types";
import InputNumber from 'rc-input-number';
import { CSCContext } from "../CSCContext";

class NumberInput extends React.Component {
	static contextType = CSCContext;

	constructor(props, context) {
		super(props, context);
		
		let userDataValue = ( this.context.getUserData(props.name) === undefined ) ? props.value : this.context.getUserData(props.name);
		this.updateValue(userDataValue);
	}

	updateValue(newValue) {
		this.context.setUserData(this.props.name, newValue);
	}

	render() {
		return (
			<div name={this.props.name} className="number-input">
				<InputNumber 
					value={this.context.getUserData(this.props.name)}
					formatter={value => `${this.props.prefix} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
					onChange={(value) => this.updateValue(value)}
					min={this.props.min}
					max={this.props.max}
					readOnly={this.props.readOnly}
				/>
			</div>
		);
	}
}

NumberInput.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.number,
	min: PropTypes.number,
	max: PropTypes.number,
	prefix: PropTypes.string,
	readOnly: PropTypes.bool,
};

NumberInput.defaultProps = {
	value: 0,
	min: 0,
	max: 999999999,
	prefix: '',
	readOnly: false,
};

export default NumberInput;
